import sdgHeader from './ImpactAreaImages/sdgheader.svg';
import sdgImage from './ImpactAreaImages/sdgimage.svg';

export const ImpactAreaShowcase = () => (
  <div className='flex h-full w-full flex-col bg-warning-25 px-12 pb-8 pt-7'>
    <img src={sdgHeader} alt='' className='h-auto w-full max-w-[750px]' />
    <img
      src={sdgImage}
      alt=''
      className='mt-4 h-auto w-full max-w-[750px] self-center'
    />
  </div>
);
